module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter2"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch2"
    }
  }, [_vm._v("Chicken Stock, the Slow-Cooker Method")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meaty chicken thighs make a terrific chicken stock, and this stock is gold in your freezer for making sauces, soups, or casseroles. Forget that can or box of broth, even though they can save you in a pinch. This is homemade goodness you can’t buy and it’s so simple to make. The best news is that you don’t have to watch it all day!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 pounds chicken, skin removed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 large sweet onions, such as Vidalia, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 large carrots, peeled and cut into 2-inch chunks")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 stalks celery with some leaves, cut into 2-inch lengths")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon dried sage, crumbled")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("sprinkle the chicken evenly with the salt and pepper. Heat the oil in a large skillet over high heat. Add the chicken and brown evenly on all sides.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the chicken to the insert of a 5- to 7-quart slow cooker. Add the onions to the same skillet over medium-high heat and sauté until they begin to soften, about 3 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the onions to the slow-cooker insert. Deglaze the pan with the wine and bring the mixture to a boil. Add the water and scrape up any browned bits from the bottom of the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the slow-cooker insert. Add the carrots, celery, thyme, and sage to the insert. Cover and cook on high for 4 to 5 hours or on low for 8 to 10 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("remove the chicken from the slow-cooker insert (it should be falling off the bone) with a slotted spoon and transfer to a plate or cutting board. Strain the stock through a fine-mesh sieve and discard any solids. Skim off any fat from the stock and store in refrigerator or freezer containers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("remove the chicken meat from the bones, discarding the bones and any gristle or tendons. The meat can be used in soups, casseroles, or salads. Store the meat in the refrigerator for up to 2 days or in the freezer for up to 1 month.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("makes about 6 cups")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "sidebar_head"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image 1",
      "src": "images/image-01.jpg"
    }
  }), _vm._v("slow-cooker savvy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Skin off please! When cooking chicken in the slow cooker, the skin acts as a tourniquet and buckles around the meat. It is also very unappetizing and adds to the fat that you need to skim off any stock or broth. It is best to remove chicken skin before cooking.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08bd606c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008-chapter2.vue
// module id = 78
// module chunks = 0